module.exports = __webpack_public_path__ + "static/media/GLI.e374ee6f.svg";